<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ $t("Flight Review") }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul
            class="nav"
            v-if="
              [PILOT_NETWORK.REVIEWER, PILOT_NETWORK.MAAC_REVIEWER, PILOT_NETWORK.PUBLIC_SERVICE_REVIEWER].indexOf(
                pilot_network
              ) > -1
            "
          >
            <li>
              <a href="#/flight-review/offering">
                <div class="photo">
                  <img :src="offering" alt="users" />
                </div>
                <span class="sidebar-normal">{{ $t("Offering") }}</span>
              </a>
            </li>
            <li>
              <a href="#/flight-review/calendar">
                <div class="photo">
                  <img :src="calendar" alt="users" />
                </div>
                <span class="sidebar-normal">{{ $t("Calendar") }}</span>
              </a>
            </li>
            <li>
              <a href="#/flight-review/reviewerBookingList">
                <div class="photo">
                  <img :src="offering" alt="Booking List" />
                </div>
                <span class="sidebar-normal">{{ $t("Booking List") }}</span>
              </a>
            </li>
          </ul>
          <ul class="nav" v-else>
            <li>
              <a href="#/flight-review/requirement">
                <div class="photo">
                  <img :src="calendar" alt="Booking Flight Review" />
                </div>
                <span class="sidebar-normal">{{
                  $t("Booking Flight Review")
                }}</span>
              </a>
            </li>
            <li>
              <a href="#/flight-review/bookingList">
                <div class="photo">
                  <img :src="offering" alt="Booking List" />
                </div>
                <span class="sidebar-normal">{{ $t("Booking List") }}</span>
              </a>
            </li>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapFields } from "vuex-map-fields";
import { USER_TYPE, PILOT_NETWORK } from "@/const.js";

export default {
  components: {
    CollapseTransition
  },
  props: {
    avatar: {
      type: String,
      default: "./img/flight_reviewer.png"
    },
    offering: {
      type: String,
      default: "./img/offering.png"
    },
    calendar: {
      type: String,
      default: "./img/calendar.png"
    }
  },
  data() {
    return {
      USER_TYPE,
      PILOT_NETWORK,
      isClosed: true
    };
  },
  computed: {
    ...mapFields("auth", ["usertype", "plan_type", "pilot_network"])
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
